import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpandAlt } from '@fortawesome/free-solid-svg-icons';
import { getCssVar } from 'utils';

interface IExpandIconProps {
  onClick?: () => void;
}

export const ExpandIcon = ({ onClick }: IExpandIconProps) => {
  return (
    <div
      style={{
        position: 'absolute',
        right: 10,
        top: 10,
        width: 21,
        textAlign: 'center',
        color: getCssVar('--gray-300'),
        cursor: 'pointer',
      }}
      onClick={onClick}
      data-testid="expand-icon"
    >
      <FontAwesomeIcon icon={faExpandAlt} size="1x" />
    </div>
  );
};
